module.exports = __webpack_public_path__ + "img/frame (118).33308432.jpg";